class BritishColumbiaResourcesDiscussionTopics {
    // First to third trimester
    public NutritionFolicAcid: boolean = false;
    public OccupationalConcerns: boolean = false;
    public MentalHealth: boolean = false;
    public Immunization: boolean = false;
    public HealthyWeightGain: boolean = false;
    public PersonalSafety: boolean = false;
    public SubstanceUse: boolean = false;
    public VaginalBirthAfterCaesareanCounseling: boolean = false;
    public PhysicalActivity: boolean = false;
    public SupportSystem: boolean = false;
    public SexualActivity: boolean = false;

    // First trimester
    public NauseaVomiting: boolean = false;
    public Exposures: boolean = false;
    public EarlyPregnancyLoss: boolean = false;
    public BreastfeedingBeliefs: boolean = false;
    public Safety: boolean = false;
    public Travel: boolean = false;
    public RoutinePrenatalCare: boolean = false;
    public QualityEducationalResources: boolean = false;
    public OralHealth: boolean = false;
    public PrenatalGeneticScreening: boolean = false;
    public PublicHealthServices: boolean = false;

    // Second trimester
    public Bleeding: boolean = false;
    public LifestyleAndSocialRisk: boolean = false;
    public PromoteHealthyBirth: boolean = false;
    public BreastfeedingImportanceSkinToSkinCare: boolean = false;
    public PretermLabour: boolean = false;
    public GestationalDiabetesScreening: boolean = false;
    public BirthPlanTravelCommunity: boolean = false;
    public PostpartumContraceptionSecondTrimester: boolean = false;
    public PrematureRuptureOfMembranes: boolean = false;
    public PrenatalClasses: boolean = false;

    // Third trimester
    public FetalMovement: boolean = false;
    public BirthPlanLabourSupport: boolean = false;
    public Erythromycin: boolean = false;
    public PostpartumCare: boolean = false;
    public EmergencyContact: boolean = false;
    public PotentialInterventions: boolean = false;
    public VitaminKProphylaxis: boolean = false;
    public PostpartumContraceptionThirdTrimester: boolean = false;
    public ExternalCephalicVersion: boolean = false;
    public GenitalHerpesSuppression: boolean = false;
    public NewbornCare: boolean = false;
    public DischargePlanning: boolean = false;
    public IndicationsForInductionOfLabour: boolean = false;
    public GroupBStreptococcusScreening: boolean = false;
    public BreastfeedingAdjustment: boolean = false;
    public InfantSafeSleep: boolean = false;
    public SignsSymptomsOfLabour: boolean = false;
    public CordBloodBanking: boolean = false;
    public WorkPlanMaternityLeave: boolean = false;
    public EdinburghPostnatalDepressionScaleScreening: boolean = false;

    constructor(fields?: Partial<BritishColumbiaResourcesDiscussionTopics>) {
        Object.assign(this, fields);
    }
}

export { BritishColumbiaResourcesDiscussionTopics };
